import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './styles/Kidola.css';

function SuccessPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate('/'); // Redirect ke halaman utama atau halaman lain yang diinginkan
  };

  return (
    <div className="search-container">
        <table>
          <tbody>
            <tr>
              <td><center><h1>Success!</h1></center></td>
            </tr>
            <tr>
              <td>
              <center><p>{location.state?.message || 'Data berhasil diinput!'}</p></center>
              </td>
            </tr>
            <tr>
              <td>
                <button onClick={handleGoBack}>Kembali ke Home</button>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default SuccessPage;
